import { render } from "./App.vue?vue&type=template&id=fcb0aa56"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=fcb0aa56&lang=scss"

import exportComponent from "D:\\CTS_SURAJ\\know_your_doctor\\ui-admin-code\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__